const base = "cui-dialog-9mzj";
const modal = "cui-dialog-modal-inu6";
const close = "cui-dialog-close-asmy";
const backdrop = "cui-dialog-backdrop-s2uo";
const classes = {
  base,
  modal,
  close,
  backdrop
};
export {
  backdrop,
  base,
  close,
  classes as default,
  modal
};
